import { Component, computed, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { Icon } from '../../icon/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'li[app-heart-zone-rate-zone-data-block-item]',
  styleUrl: './heart-rate-zone-data-block-item.scss',
  imports: [Icon, DataItemTemplate, TranslateModule],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      <app-icon [size]="iconSize()" class="icon" icon="cardio" />
      <p class="name" translate>common.metric.heartrate.zone</p>
      <div class="zone">
        @for (bar of [].constructor(5); track $index) {
          @let active = $index + 1 === zone();
          <div class="bar" [class.active]="active">
            @if (active) {
              {{ zone() }}
            }
          </div>
        }
      </div>
      <div class="heart-rate">
        {{ bpm() }}<span class="unit" translate>common.metric.heartrate.short </span>
      </div>
    </app-data-item-template>
  `,
})
export class HeartRateZoneDataBlockItem extends DataItemTemplate {
  zone: Signal<number> = computed(() => this.broadcastData().heartRateZone);
  bpm: Signal<number> = computed(() => this.broadcastData().heartRate);
}
